import { observable, action, configure, flow } from 'mobx';
import DictionariesApi from '@api/dictionaries.api';

interface IDictionariesStore {
  data: { title: string, type: string, address: string, location: string }[],
  nursery: { title: string, type: string, address: string, location: string }[],
  juniorSchool: { title: string, type: string, address: string, location: string }[],
  middleSchool: { title: string, type: string, address: string, location: string }[],
  projectInstitution: { title: string, type: string, address: string, location: string }[],
  institution: any,
  isLoading: boolean,
  err: any
}

configure({ enforceActions: 'observed' });

const isNursery = (type: string) => type === 'Nursery';

class DictionariesStore implements IDictionariesStore {
  @observable data: any[] = [];

  @observable nursery: any[] = [];

  @observable juniorSchool: any[] = [];

  @observable middleSchool: any[] = [];

  @observable projectInstitutions: any[] = [];

  @observable institution: any = {};

  @observable alert: any = null;

  @observable isLoading = false;

  @observable errors: any = null;

  @action.bound
  handleChange ({ target: { name, value } }: { target: HTMLInputElement }) {
    this.institution[name] = value;
  }

  @action.bound
  setInstitution (institution: any) {
    this.institution = institution;
  }

  @action.bound
  setAlert (alert: any) {
    this.alert = alert;
  }

  addInstitution = flow(function* addInstitution (params: any) {
    this.isLoading = true;
    try {
      yield DictionariesApi.add(params);

      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  deleteIstitution = flow(function* deleteIstitution (id: string) {
    this.isLoading = true;
    try {
      yield DictionariesApi.delete(id);

      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  getInstitutionsList = flow(function* getInstitutionsList (type: string) {
    this.isLoading = true;
    try {
      const list = yield DictionariesApi.fetch(type);

      if (isNursery(type)) {
        this.nursery = list;
      } else if (type === 'JuniorSchool') {
        this.juniorSchool = list;
      } else {
        this.middleSchool = list;
      }
      this.data = list;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  getInstitutionsListByProject = flow(function* getInstitutionsListByProject (id: string) {
    this.isLoading = true;
    try {
      const list = yield DictionariesApi.fetchByProject(id);

      this.projectInstitutions = list;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });
}

export default new DictionariesStore();
